
import { useEffect, useRef } from 'react';

function Differentiator() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-10');
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-32" style={{ background: '#F5F5F7' }}>
      <div
        ref={sectionRef}
        className="max-w-7xl mx-auto px-6 lg:px-12 opacity-0 translate-y-10 transition-all duration-700 ease-out"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-sm font-medium tracking-[0.2em] uppercase text-[#2DD4BF] mb-6">
              Our Difference
            </p>

            <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-10 leading-[1.1] tracking-tight">
              We Act as Strategic AI Advisors — Not Automation Vendors
            </h2>

            <div className="space-y-6 text-base text-gray-500 leading-relaxed font-light">
              <p className="font-normal text-gray-600">
                Most agencies implement tools.
              </p>
              <p className="font-semibold text-gray-900 text-xl tracking-tight">
                Wazier AI designs operational architecture.
              </p>
              <p>
                We begin with audit and strategic mapping before implementation. Every system is aligned to measurable business outcomes.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/ccae5c81f4830f2928e58af302aa7a4c.jpg"
                alt="Strategic AI Architecture"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Differentiator;
